/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const kamadoGrillBaseComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('KamadoGrillBase').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_LYNX-CGBDD-30-OPN_BODY',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=kamado-grill-base.js.map